import styled from 'styled-components';
import {createGlobalStyle} from 'styled-components';

// Media queries compartidas
export const media = {
    mobile: '@media (max-width: 480px)',
    tablet: '@media (max-width: 768px)',
    laptop: '@media (max-width: 1024px)',
    desktop: '@media (min-width: 1025px)'
};

// Estilos globales
export default createGlobalStyle`
*{@import url('https://fonts.googleapis.com/css2?family=Montserrat&display=swap');
.swal2-container {
  z-index: 2000 !important;
}

}

/* Mejoras para móviles */
@media (max-width: 480px) {
  body {
    -webkit-overflow-scrolling: touch;
  }
  
  /* Mejorar la experiencia táctil */
  button, input, select, textarea {
    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation;
  }
  
  /* Scroll suave en móviles */
  * {
    -webkit-overflow-scrolling: touch;
  }
  
  /* Prevenir zoom en inputs en iOS */
  input[type="text"],
  input[type="email"],
  input[type="number"],
  input[type="date"],
  input[type="time"],
  select,
  textarea {
    font-size: 16px !important;
  }
}
`;

// Componentes base compartidos
export const Icon = styled.img`
    width: ${props => props.width};
    margin: ${props => props.margin};
`;

export const StyledModal = styled.div`
    z-index:1;
    position:absolute;
    background-color:white;
    display:flex;
    flex-direction:column;
    align-items:center;
    font-family: 'Montserrat', sans-serif;
    width: 85vw;
    margin-top: 30px;
    
    ${media.tablet} {
        width: 90vw;
        margin-top: 20px;
    }
    
    ${media.mobile} {
        width: 95vw;
        margin-top: 15px;
    }
`;

export const BotonNaranja = styled.button`
    border:none;
    background: #E7973C;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 10px;
    display: flex;
    box-sizing: border-box;
    margin:20px;
    padding:10px 15px;
    justify-content: center;
    font-size: 12px;
    align-items: center;
    cursor:pointer;
    
    ${media.tablet} {
        margin: 15px;
        padding: 8px 12px;
        font-size: 11px;
        border-radius: 8px;
    }
    
    ${media.mobile} {
        margin: 10px;
        padding: 8px 10px;
        font-size: 10px;
        border-radius: 6px;
        width: 100%;
    }
`;

export const CalendarField = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 100%;
`;

export const CalendarFieldLabel = styled.label`
    font-size: 13px;
    font-weight: 600;
    color: hsl(0, 0%, 30%);
    
    ${media.tablet} {
        font-size: 12px;
    }
    
    ${media.mobile} {
        font-size: 11px;
    }
`;

export const CalendarInput = styled.input`
    width: 100%;
    padding: 10px 14px;
    border: 1px solid hsl(220, 13%, 91%);
    border-radius: 10px;
    font-size: 14px;
    color: hsl(0, 0%, 20%);
    background: #FFFFFF;
    box-sizing: border-box;
    transition: border 0.2s ease, box-shadow 0.2s ease;

    &:focus {
        border-color: hsl(24, 85%, 60%);
        box-shadow: 0px 0px 0px 3px hsla(24, 85%, 60%, 0.25);
        outline: none;
    }
    
    ${media.tablet} {
        padding: 8px 12px;
        font-size: 13px;
        border-radius: 8px;
    }
    
    ${media.mobile} {
        padding: 8px 10px;
        font-size: 12px;
        border-radius: 6px;
    }
`;

export const CalendarTextarea = styled.textarea`
    width: 100%;
    min-height: 80px;
    padding: 10px 14px;
    border: 1px solid hsl(220, 13%, 91%);
    border-radius: 10px;
    font-size: 14px;
    font-family: inherit;
    color: hsl(0, 0%, 20%);
    background: #FFFFFF;
    box-sizing: border-box;
    resize: vertical;
    transition: border 0.2s ease, box-shadow 0.2s ease;

    &:focus {
        border-color: hsl(24, 85%, 60%);
        box-shadow: 0px 0px 0px 3px hsla(24, 85%, 60%, 0.25);
        outline: none;
    }

    ${media.tablet} {
        min-height: 70px;
        padding: 8px 12px;
        font-size: 13px;
        border-radius: 8px;
    }

    ${media.mobile} {
        min-height: 60px;
        padding: 8px 10px;
        font-size: 12px;
        border-radius: 6px;
    }
`;

// Wrapper externo del calendario.
// Tiene poco padding para ganar espacio vertical y evitar scroll del navegador.
export const CalendarWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: stretch;
    padding: 6px 16px;
    box-sizing: border-box;
    flex: 1 1 auto;
    min-height: 0;
    overflow: hidden;
    
    ${media.tablet} {
        padding: 5px 12px;
    }
    
    ${media.mobile} {
        height: auto;
        padding: 5px 10px;
        overflow: visible;
    }
`;

// Caja blanca principal del calendario.
// Ocupa todo el alto disponible dentro de CalendarMainContainer.
export const CalendarContainer = styled.div`
    width: 100%;
    height: 100%;
    max-width: 1400px;
    background: #FFFFFF;
    border: 1px solid #23AAAF;
    border-radius: 14px;
    box-shadow: 0px 12px 35px rgba(0, 0, 0, 0.10), 0px 4px 14px rgba(0, 0, 0, 0.06);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
    
    ${media.tablet} {
        border-radius: 12px;
    }
    
    ${media.mobile} {
        height: auto;
        border-radius: 8px;
        border: 1px solid #23AAAF;
        overflow: visible;
    }
`;

// Header interno del calendario.
// Lo dejamos más compacto para que la grilla de turnos tenga más altura visible.
export const CalendarHeader = styled.div`
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    gap: 10px;
    padding: 8px 16px;
    border-bottom: 1px solid hsl(220, 13%, 91%);
    flex-shrink: 0;
    
    ${media.tablet} {
        padding: 7px 12px;
        gap: 8px;
    }
    
    ${media.mobile} {
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 8px 10px;
        align-items: stretch;
    }
`;

// Grupo de elementos dentro del header.
// Reducimos gaps para que el header ocupe menos espacio horizontal y vertical.
export const CalendarGroup = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: ${props => props.justify || 'flex-start'};
    justify-self: ${props => {
        if (props.justify === 'center') return 'center';
        if (props.justify === 'flex-end') return 'end';
        return 'start';
    }};
    text-align: ${props => (props.justify === 'center' ? 'center' : 'left')};
    
    ${media.tablet} {
        gap: 8px;
    }
    
    ${media.mobile} {
        gap: 8px;
        justify-content: center;
        width: 100%;
        
        &:first-child {
            order: 2;
        }
        
        &:nth-child(2) {
            order: 1;
        }
        
        &:last-child {
            order: 3;
        }
    }
`;

// Título del mes/año.
// Más chico para liberar espacio vertical.
export const CalendarTitle = styled.h1`
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    color: hsl(0, 0%, 20%);
    
    ${media.tablet} {
        font-size: 14px;
    }
    
    ${media.mobile} {
        font-size: 13px;
    }
`;

// Botón HOY.
// Menos padding para compactar el header.
export const PrimaryButton = styled.button`
    border: none;
    border-radius: 8px;
    padding: 7px 14px;
    font-size: 13px;
    font-weight: 600;
    background: hsl(24, 85%, 60%);
    color: #FFFFFF;
    cursor: pointer;
    transition: opacity 0.2s ease;

    &:hover {
        opacity: 0.9;
    }
    
    ${media.tablet} {
        padding: 6px 12px;
        font-size: 12px;
    }
    
    ${media.mobile} {
        padding: 6px 10px;
        font-size: 12px;
        border-radius: 6px;
    }
`;

// Botones con ícono: flechas, agregar, etc.
// Los hacemos más compactos para ganar espacio.
export const IconButton = styled.button`
    border: none;
    border-radius: 8px;
    padding: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${props => {
        if (props.variant === 'primary') return 'hsl(24, 85%, 60%)';
        if (props.variant === 'secondary') return 'hsl(210, 40%, 96%)';
        return 'transparent';
    }};
    color: ${props => {
        if (props.variant === 'primary') return '#FFFFFF';
        if (props.variant === 'secondary') return 'hsl(24, 85%, 60%)';
        return 'hsl(0, 0%, 35%)';
    }};
    cursor: pointer;
    transition: background 0.2s ease, opacity 0.2s ease;

    &:hover {
        opacity: 0.9;
        background: ${props => {
            if (props.variant === 'primary') return 'hsl(24, 85%, 60%)';
            if (props.variant === 'secondary') return 'hsl(210, 40%, 92%)';
            return 'rgba(226, 232, 240, 0.5)';
        }};
    }
    
    ${media.tablet} {
        padding: 6px;
    }
    
    ${media.mobile} {
        padding: 4px;
        border-radius: 6px;
    }
`;

export const ViewToggle = styled.div`
    display: flex;
    background: hsl(210, 40%, 96%);
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid hsl(220, 13%, 91%);
    
    ${media.tablet} {
        border-radius: 8px;
    }
    
    ${media.mobile} {
        border-radius: 6px;
        width: 100%;
        justify-content: center;
    }
`;

// Botones MES / SEMANA / DÍA.
// Se achican para que el header sea más liviano.
export const ViewToggleButton = styled.button`
    border: none;
    padding: 7px 16px;
    font-size: 12px;
    font-weight: 600;
    color: ${props => props.active ? '#FFFFFF' : 'hsl(0, 0%, 35%)'};
    background: ${props => props.active ? 'hsl(24, 85%, 60%)' : 'transparent'};
    cursor: pointer;
    transition: opacity 0.2s ease, background 0.2s ease, color 0.2s ease;

    &:hover {
        opacity: 0.9;
        background: ${props => props.active ? 'hsl(24, 85%, 60%)' : 'hsl(210, 40%, 92%)'};
    }

    & + & {
        border-left: 1px solid hsl(220, 13%, 91%);
    }
    
    ${media.tablet} {
        padding: 6px 12px;
        font-size: 12px;
    }
    
    ${media.mobile} {
        padding: 6px 10px;
        font-size: 11px;
        flex: 1;
    }
`;

// Texto central del período.
// Ejemplo: "3 AGO - 9 AGO".
export const CalendarPeriodLabel = styled.span`
    font-size: 15px;
    font-weight: 600;
    color: hsl(0, 0%, 20%);
    text-align: center;
    min-width: 130px;
    
    ${media.tablet} {
        font-size: 14px;
        min-width: 115px;
    }
    
    ${media.mobile} {
        font-size: 13px;
        min-width: 100px;
    }
`;

// Sección donde se renderiza Mes / Semana / Día.
// Tiene min-height: 0 para que los hijos puedan scrollear internamente.
export const CalendarSection = styled.div`
    border-bottom: ${props => props.noBorder ? 'none' : '1px solid hsl(220, 13%, 91%)'};
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    min-height: 0;
    
    ${media.mobile} {
        overflow: visible;
        height: auto;
        min-height: 0;
    }
`;

// Contenedor principal del módulo calendario.
// Usamos un alto controlado para que no vuelva el scroll general del navegador.
// Si en alguna pantalla todavía aparece scroll del navegador, subir 115px a 125px.
export const CalendarMainContainer = styled.div`
    width: 100%;
    height: calc(100vh - 115px);
    height: calc(100dvh - 115px);
    padding: 3px 0 4px;
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    align-items: stretch;
    overflow: hidden;
    min-height: 0;
    box-sizing: border-box;

    ${media.tablet} {
        height: calc(100vh - 115px);
        height: calc(100dvh - 115px);
        padding: 3px 0 4px;
    }

    ${media.mobile} {
        height: auto;
        min-height: 0;
        overflow: visible;
        padding: 5px 0;
    }
`;

// Estilos para el modal de react-modal
export const modalStyles = {
  overlay: {
    backgroundColor: 'rgba(15, 23, 42, 0.55)',
    zIndex: 1000,
    padding: '32px 20px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    overflowY: 'auto',
  },
  content: {
    position: 'relative',
    top: 'auto',
    left: 'auto',
    right: 'auto',
    bottom: 'auto',
    transform: 'none',
    border: 'none',
    background: 'transparent',
    padding: 0,
    maxWidth: '520px',
    width: '100%',
    overflow: 'visible',
  },
};

// Estilos específicos para móviles del modal
export const mobileModalStyles = {
  overlay: {
    backgroundColor: 'rgba(15, 23, 42, 0.55)',
    zIndex: 1000,
    padding: '10px',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    overflowY: 'auto',
  },
  content: {
    position: 'relative',
    top: 'auto',
    left: 'auto',
    right: 'auto',
    bottom: 'auto',
    transform: 'none',
    border: 'none',
    background: 'transparent',
    padding: 0,
    maxWidth: '95vw',
    width: '100%',
    overflow: 'visible',
  },
};
